import AxiosInstance from "./api";

export const AccountingVouchersService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/accounting-vouchers", {
      params: query,
    });
  },

  getInit: async () => {
    return await AxiosInstance.get("/private/accounting-vouchers/init");
  },

  getById: async (id) => {
    return await AxiosInstance.get(`/private/accounting-vouchers/${id}`);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/accounting-vouchers", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/accounting-vouchers/${id}`, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete(`/private/accounting-vouchers/${id}`);
  },

  getHybridSources: async (payload) => {
    const query = new URLSearchParams(payload);
    try {
      return await AxiosInstance.get("/private/accounting-vouchers/hybrid/sources", {
        params: query,
      });
    } catch (error) {
      if (error?.response?.status !== 404) throw error;
      return await AxiosInstance.get("/private/accounting-vouchers/sources/hybrid", {
        params: query,
      });
    }
  },

  previewHybrid: async (payload) => {
    try {
      return await AxiosInstance.post("/private/accounting-vouchers/hybrid/preview", payload);
    } catch (error) {
      if (error?.response?.status !== 404) throw error;
      return await AxiosInstance.post("/private/accounting-vouchers/preview/hybrid", payload);
    }
  },

  postVoucher: async (id) => {
    return await AxiosInstance.post(`/private/accounting-vouchers/${id}/post`);
  },

  reverseVoucher: async (id, payload) => {
    return await AxiosInstance.post(`/private/accounting-vouchers/${id}/reverse`, payload);
  },

  getSources: async (id) => {
    return await AxiosInstance.get(`/private/accounting-vouchers/${id}/sources`);
  },
};
